'use client';

import dynamic from 'next/dynamic';
import type { ReactNode } from 'react';
import { Cart, Header } from 'components/shared';

const ChatBot = dynamic(() => import('components/shared/WAChatbot'), {
  ssr: false,
});

/**
 * Global site chrome — rendered by the (site) route-group layout around page
 * content. The (lite) group (order flows) omits it entirely, replacing the
 * Pages Router's client-side `useGlobalUI({ liteUI })` hide mechanism.
 * `footer` is passed in as a prop so it can stay a Server Component.
 */
export function SiteChrome({
  children,
  footer,
}: {
  children: ReactNode;
  footer: ReactNode;
}) {
  return (
    <>
      <Header />
      {children}
      <Cart />
      {footer}
      <ChatBot />
    </>
  );
}
